import { todayStr } from "../../constants/categories";

export default function DuolingoStyle({
  histMap, completedCount, streak,
  calMonth, calYear, monthDays, firstDayOfWeek, monthNames,
  prevMonth, nextMonth, isCurrentMonth,
  selectedDay, setSelectedDay,
  thisWeek, weekCompleted, isPerfectWeek,
  streakNum, nextMilestone, milestoneProgress,
}) {
  return (
    <>
      {/* Streak Hero */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "20px", padding: "28px 20px", marginBottom: "20px", textAlign: "center", position: "relative", overflow: "hidden", boxShadow: "var(--card-shadow)" }}>
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(circle at 50% 30%, #FF960012, transparent 70%)", pointerEvents: "none" }} />
        <div style={{ fontSize: "56px", marginBottom: "4px", filter: streakNum > 0 ? "none" : "grayscale(1) opacity(0.4)" }}>
          {streakNum > 0 ? "🔥" : "🧊"}
        </div>
        <div style={{ fontSize: "44px", fontWeight: "900", color: streakNum > 0 ? "#FF9600" : "var(--text-dim)", lineHeight: 1 }}>{streakNum}</div>
        <div style={{ fontSize: "14px", color: streakNum > 0 ? "#E68A00" : "var(--text-dim)", fontWeight: "600", marginTop: "4px" }}>
          {streakNum === 0 ? "Chưa có streak" : streakNum === 1 ? "ngày streak!" : "ngày streak liên tiếp!"}
        </div>
        {streakNum > 0 && (
          <div style={{ marginTop: "16px" }}>
            <div style={{ fontSize: "12px", color: "var(--text-tertiary)", marginBottom: "6px", fontWeight: "500" }}>Mục tiêu tiếp: {nextMilestone} ngày</div>
            <div style={{ background: "var(--bg-inset)", borderRadius: "10px", height: "10px", overflow: "hidden", maxWidth: "200px", margin: "0 auto" }}>
              <div style={{ height: "100%", borderRadius: "10px", background: "linear-gradient(90deg, #FF9600, #FFB84D)", width: `${milestoneProgress}%`, transition: "width 0.5s ease" }} />
            </div>
            <div style={{ fontSize: "11px", color: "#E68A00", marginTop: "6px", fontWeight: "700" }}>{streakNum}/{nextMilestone}</div>
          </div>
        )}
      </div>

      {/* This Week Row */}
      <div style={{ background: "var(--bg-card)", border: isPerfectWeek ? "1px solid #FF960066" : "1px solid var(--border-secondary)", borderRadius: "16px", padding: "20px", marginBottom: "20px", position: "relative", boxShadow: "var(--card-shadow)" }}>
        {isPerfectWeek && <div style={{ position: "absolute", top: "-10px", left: "50%", transform: "translateX(-50%)", background: "linear-gradient(135deg, #FF9600, #FF6B00)", borderRadius: "12px", padding: "3px 12px", fontSize: "10px", fontWeight: "800", color: "#fff", letterSpacing: "1px" }}>TUẦN HOÀN HẢO!</div>}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {thisWeek.map((day, i) => {
            const hasCompleted = day.items.some(c => c.completed);
            const hasChallenge = day.items.length > 0;
            const completedCount2 = day.items.filter(c => c.completed).length;
            return (
              <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", flex: 1 }}
                onClick={() => hasChallenge && setSelectedDay(day.items)}>
                <div style={{ fontSize: "11px", color: day.isToday ? "#FF9600" : "var(--text-muted)", fontWeight: day.isToday ? "800" : "500" }}>{day.dayName}</div>
                <div style={{
                  width: "40px", height: "40px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: hasChallenge ? "pointer" : "default",
                  background: hasCompleted ? "linear-gradient(135deg, #FF9600, #FF6B00)" : "transparent",
                  border: day.isToday && !hasCompleted ? "2.5px solid #FF9600" : hasCompleted ? "none" : day.isFuture ? "2px solid var(--border-secondary)" : hasChallenge ? "2px solid var(--text-dim)" : "2px solid var(--border-secondary)",
                  boxShadow: hasCompleted ? "0 2px 8px #FF960033" : "none",
                  boxSizing: "border-box",
                  transition: "background 0.3s, border-color 0.3s, box-shadow 0.3s",
                }}>
                  {hasCompleted ? (
                    <span style={{ fontSize: completedCount2 > 1 ? "12px" : "14px", color: "#fff", fontWeight: "700" }}>{completedCount2 > 1 ? `🔥${completedCount2}` : "🔥"}</span>
                  ) : day.isToday ? (
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#FF9600", animation: "pulse 2s infinite" }} />
                  ) : day.isFuture ? (
                    <span style={{ fontSize: "13px", color: "var(--text-dim)" }}>{new Date(day.date).getDate()}</span>
                  ) : hasChallenge ? (
                    <span style={{ fontSize: "14px", color: "var(--text-muted)" }}>-</span>
                  ) : (
                    <span style={{ fontSize: "13px", color: "var(--text-dim)" }}>{new Date(day.date).getDate()}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ display: "flex", gap: "3px", marginTop: "14px", borderRadius: "6px", overflow: "hidden" }}>
          {thisWeek.map((day, i) => (
            <div key={i} style={{ flex: 1, height: "4px", borderRadius: "2px", background: day.items.some(c => c.completed) ? "linear-gradient(90deg, #FF9600, #FFB84D)" : "var(--border-secondary)", transition: "background 0.3s" }} />
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "10px", fontSize: "12px", color: "var(--text-muted)" }}>
          {weekCompleted}/7 ngày trong tuần
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "20px" }}>
        <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "18px", textAlign: "center", boxShadow: "var(--card-shadow)" }}>
          <div style={{ fontSize: "13px", marginBottom: "6px" }}>🏆</div>
          <div style={{ fontSize: "26px", fontWeight: "900", color: "#E68A00" }}>{streak.longest_streak || 0}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>Kỷ lục streak</div>
        </div>
        <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "18px", textAlign: "center", boxShadow: "var(--card-shadow)" }}>
          <div style={{ fontSize: "13px", marginBottom: "6px" }}>✅</div>
          <div style={{ fontSize: "26px", fontWeight: "900", color: "#16A34A" }}>{completedCount}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "2px" }}>Ngày hoàn thành</div>
        </div>
      </div>

      {/* Monthly Calendar - Duolingo style */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "20px", marginBottom: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <button onClick={prevMonth} style={{ background: "none", border: "none", color: "var(--text-tertiary)", cursor: "pointer", fontSize: "20px", padding: "4px 10px" }}>‹</button>
          <div style={{ fontSize: "16px", fontWeight: "700", color: "var(--text-primary)" }}>{monthNames[calMonth]} {calYear}</div>
          <button onClick={nextMonth} style={{ background: "none", border: "none", color: isCurrentMonth ? "var(--border-primary)" : "var(--text-tertiary)", cursor: isCurrentMonth ? "default" : "pointer", fontSize: "20px", padding: "4px 10px" }}>›</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "6px", textAlign: "center" }}>
          {["T2","T3","T4","T5","T6","T7","CN"].map(d => (
            <div key={d} style={{ fontSize: "11px", color: "var(--text-dim)", padding: "6px 0", fontWeight: "700" }}>{d}</div>
          ))}
          {Array.from({ length: (firstDayOfWeek + 6) % 7 }).map((_, i) => <div key={`e${i}`} />)}
          {Array.from({ length: monthDays }).map((_, i) => {
            const day = i + 1;
            const dateStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            const items = histMap[dateStr] || [];
            const hasCompleted = items.some(c => c.completed);
            const hasData = items.length > 0;
            const isToday = dateStr === todayStr;
            const isFuture = dateStr > todayStr;
            const isSelected = Array.isArray(selectedDay) && selectedDay[0]?.date === dateStr;
            const completedN = items.filter(c => c.completed).length;
            return (
              <div key={day} onClick={() => !isFuture && hasData && setSelectedDay(items)}
                style={{
                  aspectRatio: "1", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                  borderRadius: "50%", cursor: hasData && !isFuture ? "pointer" : "default",
                  background: isSelected ? "#FF960033" : hasCompleted ? "linear-gradient(135deg, #FF9600, #FF6B00)" : "transparent",
                  border: isToday && !hasCompleted ? "2.5px solid #FF9600" : isSelected ? "2.5px solid #FF9600" : "2.5px solid transparent",
                  boxSizing: "border-box", boxShadow: hasCompleted ? "0 2px 8px #FF960033" : "none", transition: "background 0.2s, border-color 0.2s",
                }}>
                {hasCompleted ? (
                  <span style={{ fontSize: completedN > 1 ? "11px" : "16px", color: "#fff", fontWeight: "700" }}>{completedN > 1 ? `🔥${completedN}` : "🔥"}</span>
                ) : (
                  <span style={{ fontSize: "12px", fontWeight: isToday ? "800" : "500", color: isFuture ? "var(--border-primary)" : isToday ? "#FF9600" : hasData ? "var(--text-tertiary)" : "var(--text-dim)" }}>{day}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
